/**
 * Formats duration object to string format (HH:MM)
 * @param {Object} duration - Duration object with hours and minutes
 * @param {number} duration.hours - Number of hours
 * @param {number} duration.minutes - Number of minutes
 * @returns {string} Formatted duration string
 */
export const formatDuration = (duration) => {
  if (!duration) return "";
  const { hours, minutes } = duration;
  return `${hours}:${minutes.toString().padStart(2, "0")}`;
};

